export interface RevelacoesContent {
	title: string;
	subtitle: string;
	consumptionPeak: {
		title: string;
		text: string;
	};
	goldenHour: {
		title: string;
		text: string;
	};
	championProduct: {
		title: string;
		text: string;
	};
}

export const revelacoesContent: RevelacoesContent = {
	title: "O QUE O ZIG PULSE REVELOU",
	subtitle: "Métricas por local",
	consumptionPeak: {
		title: "Melhor dia da semana",
		text: "{{dayOfWeek}} concentra {{percentageOfSales}}% do faturamento",
	},
	goldenHour: {
		title: "Horário de Ouro",
		text: "{{timeRange}} concentra {{percentageOfSales}}% do faturamento",
	},
	championProduct: {
		title: "Produto Campeão de Faturamento",
		text: "{{name}} lidera com {{percentage}}% do volume total do faturamento",
	},
};
